import { Button } from '@/components/Elements';
import { InputField } from '@/components/Form';
import { usePostPasswordReset } from '@/features/password-reset/api/postPasswordReset';
import { PasswordResetLayout } from '@/features/password-reset/components/Layout';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

export const CreatePasswordRest = () => {
  const { t } = useTranslation();
  const { mutate, isPending } = usePostPasswordReset();
  const [requestSuccess, setRequestSuccess] = useState<boolean>(false);
  const [email, setEmail] = useState<string>('');

  const onSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    mutate(
      { email },
      {
        onSuccess: () => {
          setRequestSuccess(true);
        },
      }
    );
  };

  return (
    <PasswordResetLayout>
      <form className="w-full space-y-6" onSubmit={onSubmit}>
        {requestSuccess ? (
          <div>
            {t('パスワード設定用のメールを送信しました。')}
            <br />
            {t(
              'しばらくしてもメールが届かない場合は、迷惑メールフォルダをご確認ください。また、登録されていないメールアドレスには送信できません。'
            )}
          </div>
        ) : (
          <>
            <div>
              {t(
                'パスワード設定用のメールを送信します。登録されているメールアドレスを入力してください。'
              )}
            </div>

            <InputField
              // ref={emailRef}
              label={t('メールアドレス')}
              type="email"
              autoComplete="email"
              placeholder={t('メールアドレスを入力...')}
              value={email}
              onChange={(e) => setEmail(e.currentTarget.value)}
              required
            />

            <Button
              type="submit"
              size="sm"
              className="w-full"
              isLoading={isPending}
            >
              {t('送信')}
            </Button>
          </>
        )}
      </form>
    </PasswordResetLayout>
  );
};
